/** Renders a number as text, or `null` when the value is missing. */
export const numberToText = (value?: number | null) =>
  value == null ? null : String(value);

/** Compares two numbers, placing `null` after every number. */
export const compareNullableNumbers = (a: number | null, b: number | null) => {
  if (a === b) return 0;
  if (a === null || b === null) return a === null ? 1 : -1;

  return a - b;
};
